import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Carmen R.',
    meta: '62 años — Miami, FL',
    text: 'Llevaba 4 años despertándome a las 3 de la mañana. En la tercera noche de seguir el protocolo dormí de un tirón hasta las 7. No lo podía creer.'
  }, {
    name: 'Roberto M.',
    meta: '58 años — Houston, TX',
    text: 'Probé de todo. Pastillas, melatonina, tés... nada funcionaba. Este protocolo me devolvió el sueño que tenía a los 40. Vale cada centavo.'
  }, {
    name: 'María T.',
    meta: '65 años — Los Angeles, CA',
    text: 'El audio de inducción es lo mejor. Me lo pongo cuando me despierto a mitad de la noche y en minutos estoy dormida de nuevo. Increíble.'
  }];
  return <section className="py-20 md:py-24 bg-[#0a0e1a]" data-id="element-284">
      <div className="max-w-6xl mx-auto px-6" data-id="element-285">
        <FadeIn data-id="element-286">
          <h2 className="text-3xl md:text-4xl font-serif text-center mb-4 text-glow" data-id="element-287">
            Historias de quienes ya duermen mejor
          </h2>
          <p className="text-center text-cream-muted text-body-lg mb-14 max-w-2xl mx-auto" data-id="element-288">
            Personas reales que recuperaron sus noches con el protocolo.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8" data-id="element-289">
          {testimonials.map((t, i) => <FadeIn key={i} delay={0.1 + i * 0.1} data-id="element-290">
              <article className="card-glass rounded-md p-7 h-full flex flex-col relative" data-id="element-291">
                <QuoteIcon className="absolute top-5 right-5 w-8 h-8 text-gold-500/20" data-id="element-292" />
                <div className="flex gap-1 mb-5" data-id="element-293">
                  {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-5 h-5 text-gold-400 fill-gold-400" data-id="element-294" />)}
                </div>
                <p className="text-white leading-relaxed mb-6 flex-grow text-body-lg italic font-serif" data-id="element-295">
                  "{t.text}"
                </p>
                <div className="pt-5 border-t border-white/15" data-id="element-296">
                  <p className="font-medium text-white" data-id="element-297">{t.name}</p>
                  <p className="text-sm text-cream-muted" data-id="element-298">{t.meta}</p>
                </div>
              </article>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}